import ClassSpellManager from './ClassSpellManager';

export default ClassSpellManager;
export { ClassSpellManager };
